import { c as _c } from "react/compiler-runtime";
import { StyledToggle, StyledToggleCircle } from "./Toggle.style";
export const Toggle: React.FC<{
  active: boolean;
  onChange: (active: boolean) => void;
  dataCy?: string;
}> = t0 => {
  const $ = _c(14);
  const {
    active,
    onChange,
    dataCy
  } = t0;
  let t1;
  if ($[0] !== active || $[1] !== onChange) {
    t1 = e => {
      e.currentTarget.blur();
      onChange(!active);
    };
    $[0] = active;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== active) {
    t2 = active.toString();
    $[3] = active;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== active) {
    t3 = active.toString();
    $[5] = active;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <StyledToggleCircle active={t3} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== dataCy || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <StyledToggle onClick={t1} active={t2} data-cy={dataCy}>{t4}</StyledToggle>;
    $[9] = dataCy;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};